@let currency = currency$ | async;
@let isCurrencyUSD = currency ? currency.isocode === 'USD' : null;
@let elevatedAccess = elevatedAccess$ | async;
<div class="grid grid-cols-3 gap-medpace">
    <mds-text-field
        appDisableMouseScroll
        id="deducted-amount"
        data-cy="deducted-amount"
        [formCtrl]="formGrp().controls.amount"
        inputType="decimal"
        [decimalPlaces]="2"
        placeholder="Type here..."
        appearance="outline"
        [label]="!currency ? 'Deducted' : `Deducted (${currency.isocode})`"
    ></mds-text-field>
    @if (elevatedAccess && isCurrencyUSD === false) {
        <mds-text-field
            appDisableMouseScroll
            id="deducted-amount-converted"
            data-cy="deducted-amount-converted"
            [formCtrl]="formGrp().controls.amountConverted"
            inputType="decimal"
            [decimalPlaces]="2"
            placeholder="Type here..."
            appearance="outline"
            [label]="'Deducted (USD)'"
        ></mds-text-field>
    }
    <mds-dropdown
        [filterable]="true"
        [closeOnPageScroll]="false"
        [appearance]="'outline'"
        [label]="'Currency'"
        [placeholder]="'Select currency'"
        [options]="(currencyOptions$ | async) ?? []"
        id="deducted-currency"
        data-cy="deducted-currency"
        [formCtrl]="formGrp().controls.currency"
    ></mds-dropdown>
</div>
